import { Component, Input, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { first } from 'rxjs';
import { User } from 'src/app/models/user';
import { AutomationService } from 'src/app/services/automation.service';
import { ControlService } from 'src/app/services/control.service';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-screenshots',
    templateUrl: './screenshots.component.html',
    styleUrls: ['./screenshots.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class ScreenshotsComponent implements OnInit {
  private baseUrl = environment.baseUrl;
  private baseUrlStorage = environment.baseUrlStorage;
  // private baseUrl=environment.baseUrl;
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate2') alertTemplate2!: TemplateRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  // @ViewChild('delete_all_Screenshot') DeleteAllScreenshot :TemplateRef<any>
  @ViewChild('downloadAllScreenshot') SaveAllScreenshot: TemplateRef<any>
  @ViewChild('DownloadDraftScreeshot') SaveAllDarftScreenshot: TemplateRef<any>
  @ViewChild('draftClearScreeshot') draftDeleteScreeshot: TemplateRef<any>

  @ViewChild('DownloadAsPdfScreeshot') DownloadAsPdfScreeshot: TemplateRef<any>

  msg: string = "";
  @ViewChild('newimg', { static: true }) newimg: ElementRef<HTMLImageElement>;
  @Input() control: ControlService;
  @Input() device: any;
  currentUser: User;
  isScreenrecord: Boolean = true;
  isDraft: Boolean = false

  screenshots: any[] = [];
  newArray: any[] = [];
  screenShotSize = 400;
  email: any;
  params: any;
  value: any;
  source: any;

  isScreenshot: boolean = false;

  constructor(
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private storageService: StorageService,
    private loginService: LoginService,
    private automationService: AutomationService,
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  showScreenshot() {
    this.isScreenshot = true;
    this.isDraft = false;

    this.screenshots = this.control.screenshots;
    this.email = this.currentUser.email;
    this.params = 100;
  }

  showScreenshotDraft() {
    this.isDraft = true;
    this.isScreenshot = false;

    this.screenshots = this.control.screenshots;
    this.email = this.currentUser.email;
    this.params = 100;

    //this.backupScreenshot();
  }

  ngOnInit() {
    window.onbeforeunload = null;

    this.showScreenshot();
  }

  /*----------------------------------------ScreenShot Section------------------------------- */

  takeScreenShot() {

    // let blob = new Blob([], {
    //   type: 'image/jpeg'
    // })
    // let url = URL.createObjectURL(blob)
    // // img.src
    // let mySrc = this.sanitizer.bypassSecurityTrustUrl(url);
    // this.source=url
    if (this.device.ios) {
      this.control.screenshotIos().then((result) => {
        result.body.href = result.body.href.replace('/s/image/', '/s/blob/');

        this.control.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    else {
      this.control.screenshot().then((result) => {
        result.body.href = result.body.href.replace('/s/image/', '/s/blob/');

        this.control.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    this.screenshots = this.control.screenshots;
  }

  downloadAllScreeshot() {
    this.modalRef.close();
    let download = (uri, name) => {
      let link = document.createElement("a");
      link.download = name;
      link.href = uri;
      link.click();
    }

    let counter = 0;

    for (let i = 0; i < this.screenshots.length; i++) {
      download(this.screenshots[i].body.href, "screenshot " + counter + ".png");
      counter++;
    }
  }

  downloadScreeshot() {
    this.modalRef = this.dialog.open(this.SaveAllScreenshot);
  }

  removeScreenShot(index) {
    this.screenshots.splice(index, 1);
  }

  removeAllScreenshots() {
    this.msg = "Are you sure, you want to discard all screenshots?";
    this.openAlertMod(this.alertTemplate2, this.msg);
  }

  Yes() {
    this.screenshots = [];
    this.control.screenshots = [];
    this.modalRef.close();
  }

  No() {
    this.modalRef.close();
  }

  downloadSSasPDF2() {
    let inputStrings = [];

    this.control.screenshots.forEach((ss) => {
      let url = window.location.protocol + '//' + window.location.href.split('/')[2] + ss.body.href;
      inputStrings.push(url);
    })

    let providerUrl = this.automationService.getBridgeHost(this.device) + '/screenShortToPDFUrls/' + this.email;
    this.automationService.downloadSSasPDF(inputStrings, providerUrl).pipe(first()).subscribe((response: Blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(response);
      // link.download = fileName; <------check
      link.click();
    });
  }

  resizeImageOfIos(param) {
    if (this.value < param.min) {
      this.value = param.min;
    } else if (this.value > param.max) {
      this.value = param.max;
    }

    let cols = document.getElementsByClassName('screenshot-image resizeIOS') as HTMLCollectionOf<HTMLImageElement>;
    for (let i = 0; i < cols.length; i++) {
      let sampleWidth = 550 * ((this.value / 100) * param.step);
      let sampleHeight = 1000 * ((this.value / 100) * param.step);
      cols[i].style.width = (225 + sampleWidth) + 'px';
      cols[i].style.height = (400 + sampleHeight) + 'px';
    }
  }

  /*----------------------------------------ScreenShot Section--------------------------------- */
  draftAllDeleteScreenshot() {
    this.modalRef = this.dialog.open(this.draftDeleteScreeshot)
  }
  draftClear() {
    this.storageService.deleteScreenShots(this.email).pipe(first()).subscribe((data: any) => {
      this.msg = data.message;
      this.openAlertMod1(this.alertTemplate, this.msg);
      // alert(data);
    })
    this.newArray = [];
  }

  shotSizeParameter(maxSize, multiplier) {
    let finalSize = this.screenShotSize * multiplier
    let finalMaxSize = maxSize * multiplier

    return (finalSize === finalMaxSize) ? '' :
      '?crop=' + finalSize + 'x'
  }

  backupScreenshot() {
    let protocol = window.location.href.split('/')[0]
    let hostname = window.location.href.split('/')[2]
    let url = '';
    this.storageService.getScreenShot(this.email).pipe(first()).subscribe((list: any) => {

      for (let i = 0; i < list.length; i++) {
        // let fileName = list[i].name.split('.')[0];
        url = this.baseUrlStorage + '/file/latestFile?bucket=ProteanStorageImage&filePath=' + list[i];
        if (!this.newArray.includes(url)) {
          this.newArray.push(url);
        } else {
        }
      }
    })
  }
  
  DraftScreeshot() {
    this.modalRef = this.dialog.open(this.SaveAllDarftScreenshot)
  }

  downloadDraftScreeshot() {
    this.modalRef.close()
    let download = (uri, name) => {
      let link = document.createElement("a");
      link.download = name;
      link.href = uri;
      link.click();
    }
    let counter = 0;

    for (let i = 0; i < this.newArray.length; i++) {
      download(this.newArray[i], "screenshot " + counter + ".png");
      counter++;
    }
  }

  extractFilePath = (urlString: string): string => {
    try {
      // Add 'http:' prefix if needed to make it a valid URL
      const fullUrl = urlString.startsWith('http') ? urlString : `http:${urlString}`;
      const urlObj = new URL(fullUrl);
      return urlObj.searchParams.get('filePath') || '';
    } catch (e) {
      console.error("Error parsing URL:", e);
      return '';
    }
  };

  removeDraftScreenShot(index) {
    let ssNameArrayy = this.newArray[index];
    let filePath = this.extractFilePath(ssNameArrayy);
    this.newArray.splice(index, 1);

    this.storageService.deleteScreenShot(this.email, filePath).pipe(first()).subscribe((data: any) => {

    })
  }
  downloadSSasPDFScreenshot() {
    this.modalRef = this.dialog.open(this.DownloadAsPdfScreeshot)
  }


  downloadSSasPDF() {
    let fileName = "screenshorts.pdf";
    let url = window.location.protocol + '//' + window.location.href.split('/')[2] + '/file/downloadPdfFiles/' + this.email + '/screenshot';
    fetch(url).then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      })
      .catch(console.error);
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
  }

  openAlertMod1(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }
  cancelRequest() {
    this.modalRef.close()
  }
}
